import { on_ready, is_elementor_edit } from 'js/utils';
import { hover_intent } from 'js/functions';
// import { add_to_cart_ajax_init } from 'src/woocommerce/js/add_to_cart';
// import { load_swiper_mobile } from 'modules/carousel/load_swiper_mobile';

import './internals.scss';

on_ready(()=>{

    if( is_elementor_edit() ) return;

    // add_to_cart_ajax_init();

    // load_swiper_mobile();
    
    // add delay on hover out - to avoid instant close/off
    hover_intent_init();

    console.log('internals.js loaded');

    // Toggle quote details
    toggle_quote_init();
    
});

function hover_intent_init(){
    document.querySelectorAll('.hover_intent').forEach(el=>{
        const duration = el.dataset.duration || 300;
        hover_intent(el, duration);
    });
}

function toggle_quote_init() {
  document.querySelectorAll(".toggle-block").forEach(block => {
    const button = block.querySelector(".quote-button");
    const details = block.querySelector(".quote-details");

    button.addEventListener("click", (e) => {
      e.preventDefault();

      if (!details.classList.contains("open")) {
        // --- OPEN ---
        details.classList.add("open");
        const fullHeight = details.scrollHeight + "px";
        details.style.height = fullHeight;
        details.style.opacity = 1;
      } else {
        // --- CLOSE ---
        const fullHeight = details.scrollHeight + "px";
        details.style.height = fullHeight; // lock current height
        details.offsetHeight; // force reflow
        details.style.height = "0";
        details.style.opacity = 0;

        details.addEventListener(
          "transitionend",
          (event) => {
            if (event.propertyName === "height") {
              details.classList.remove("open");
            }
          },
          { once: true }
        );
      }
    });
  });
}